module.exports = __webpack_public_path__ + "static/media/Michelle-Brown-Headshot-VPMA.3c4fd51d.png";